import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  TableBody,
  IconButton,
} from "@mui/material";
import IconReusable from "../../../../components/IconReusable";


export const PreviousTripDetailsTable = ({ previousTripDetails }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="h2">Previous Trip Benefit</Typography>
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                background: "#f4f6f8",
                borderBottom: "1px dashed #919eab33",
              }}>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                }}>
                Trip Benefit
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                }}>
                Date
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  borderBottom: "none",
                }}>
                Memory
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {previousTripDetails && previousTripDetails.length > 0 ? (
              previousTripDetails.map((tripDetail, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      borderBottom: "1px dashed #919eab33",
                      cursor: "pointer",
                    }}>
                    <TableCell sx={{ borderBottom: "none" }}>
                      {tripDetail.display_label}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      {tripDetail.date}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <IconButton
                        size="small"
                        sx={{ p: 0 }}
                        // onClick={}
                      >
                        <IconReusable
                          name="DownloadOutlined"
                          color="#995A00"
                          width={"24px"}
                          height={"24px"}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow sx={{ borderBottom: "1px dashed #919eab33" }}>
                <TableCell colSpan={6} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
